import { getTableTypeToLocalizedString } from '@tableau/catalog-ui-temp';
import * as CertificationWatermark from '@tableau/certification-watermark';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';

import { ExplorerStyles } from '../../../components/Explorer/ExplorerStyles';
import { StyledCellFormatter } from '../StyledCellWrapper';

export interface ContentTypeCellOptions {
  iconTypeForRow: (row: DataGrid.Row) => (props: any) => React.ReactSVGElement | null;
  titleForIcon: (row: DataGrid.Row) => string;
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps;
  contentType?: (row: DataGrid.Row) => ExplorableItemType;
}

export const ContentTypeCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {

          const icon = options.iconTypeForRow(this.props.row);

          return (
              <div className={ExplorerStyles.ContentTypeCellContainer}>
                <span className={ExplorerStyles.ContentTypeCellImg}>
                  {icon && icon({size: ExplorerStyles.contentTypeIconSize, alt: options.titleForIcon(this.props.row)})}
                </span>
              </div>
          );
        }
      })
  );
};

export const ContentTypeTextCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
    React.createFactory(class extends React.Component<BodyCell.Props, any> {
      public render(): JSX.Element {
        return (
            <span style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {options.contentType(this.props.row) === 'table'? getTableTypeToLocalizedString(this.props.row.data.contentDetail.tableType) : options.titleForIcon(this.props.row) }
            </span>
        );
      }
    })
  ) ;
};

